import { render, staticRenderFns } from "./article-card.vue?vue&type=template&id=2853c583&"
import script from "./article-card.vue?vue&type=script&lang=js&"
export * from "./article-card.vue?vue&type=script&lang=js&"
import style0 from "./article-card.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports